import React, { Component } from 'react';

class VideoPlayer extends Component {
	render() {
		return (
			<div className="video-player">
				<div className="mask" onClick={this.props.onClose}>
					<div className="block" onClick={this.props.onClose}>
						<div className="close-btn" onClick={this.props.onClose}></div>
						{
							(this.props.mp4url.indexOf("youtube") > 0) ?
								<iframe width="100%" height="80vh" frameBorder="0" src={"http://www.youtube.com/embed/"+this.props.mp4url.split("?v=")[1]+"?html5=1&autoplay=1"}></iframe>
							:
								<video controls autoPlay>
									<source src={this.props.mp4url} type="video/mp4" />
									Your browser does not support HTML5 video.
								</video>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/VideoPlayer.js